import EventBus from '../components/layout/EventBus'

export default {
  methods: {

    async withLoading(f, settings) {
      this.startLoading(settings)
      await f();
      this.stopLoading();
    },
    startLoading (settings) {
      return EventBus.$emit("start-loading", {settings})
    },
    stopLoading () {
      return EventBus.$emit("stop-loading")
    }
  }
}
